import { Hostname, Realm, zendeskAppIds } from "../../../types";
import { constants } from "../definitions";

export const getRealm = (hostname: string): Realm | null => {
  // TODO: second clause is to allow this helper to work prior to us having help.local.twilio.com as a host for local
  const hasMatch =
    hostname.match(/help\.(?<realm>dev|stage|local)\.twilio/) ||
    hostname.match(/(?<realm>local)host/) ||
    hostname.match(/(?<realm>dev|stage|local)\.twilio\.com$/);

  if (hasMatch && hasMatch.groups) {
    return hasMatch.groups.realm as Realm;
  }

  return null;
};

export const getTwilioHost = (hostname: Hostname): Hostname => {
  return constants.realmToHost[getRealm(hostname) || Realm.prod];
};

export const getTwilioProtocol = (hostname: Hostname): string => {
  return getTwilioHost(hostname) === "www.local.twilio.com"
    ? "http://"
    : "https://";
};

/**
 * Zendesk hosted apps use an appId versus a realm to determine the environment
 */
export const determineZendeskRealm = (hostname: string): Realm | null => {
  const isZendesk = hostname.includes("apps.zdusercontent");

  if (isZendesk) {
    const zendeskRealm = hostname.includes(zendeskAppIds.sandbox.toString())
      ? Realm.stage
      : Realm.prod;

    return zendeskRealm;
  }

  return null;
};

export const determineSendgridRealm = (hostname: string): Realm | null => {
  const isSendgrid = hostname.includes("sendgrid");

  if (isSendgrid) {
    const sendgridRealm = hostname.includes("sendgridtest")
      ? Realm.stage
      : hostname.includes("support.sendgrid")
      ? Realm.prod
      : null;

    return sendgridRealm;
  }

  return null;
};

export const determineRealm = (hostname: string): Realm => {
  const zendeskRealm = determineZendeskRealm(hostname);

  // Check if we're in a Zendesk app for stage|prod
  if (zendeskRealm) {
    return zendeskRealm;
  }

  const sendgridRealm = determineSendgridRealm(hostname);
  if (sendgridRealm) {
    return sendgridRealm;
  }

  // Both ZD and SF use localhost in local environments
  const isLocalHost = hostname.match(/(?<realm>local)host/);
  // This will catch local|dev|stage for OSC and Console
  const isHelpCenterOrConsole = hostname.match(
    /(help|console)\.(?<realm>dev|stage|local)\.twilio/
  );
  // This will catch dev|stage for Salesforce
  const isSalesforce = hostname.match(
    /wiseowl-salesforce\.(?<realm>dev|stage)/
  );
  // This will catch dev|stage for Jarvis
  const isJarvis = hostname.match(/wiseowl\.(?<realm>dev|stage)/);

  const hasMatch =
    isLocalHost || isHelpCenterOrConsole || isSalesforce || isJarvis;

  /**
   * A match here will return the local|dev|stage realm for
   * OSC/Console/SF/ZD
   */
  if (hasMatch && hasMatch.groups) {
    return hasMatch.groups.realm as Realm;
  }

  // Fallback to prod Segment key for OSC/Console/SF if no match
  return Realm.prod;
};
